'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import LinkButton from '@/components/atoms/LinkButton';
import { ChevronDownIcon } from '@/public/assets/svg';
import ArrowRightIcon from '@/public/assets/svg/arrow-right.svg';
import { CryptoTableType } from '@/utils/types';
import ChangeIndicator from './partials/ChangeIndicator';
const MobileCrypto: React.FC<CryptoTableType> = t0 => {
  const $ = _c(35);
  const {
    rows: slides,
    variant,
    headers,
    feesRow,
    tooltip,
    howToButtonLabel,
    isLoading
  } = t0;
  const [currentCoin, setCurrentCoin] = useState("");
  let t1;
  if ($[0] !== headers || $[1] !== slides) {
    t1 = slides?.map(item => [{
      key: headers[1]?.text,
      value: item.buyValue
    }, {
      key: headers[2]?.text,
      value: item.buyFeeFlat
    }, {
      key: headers[3]?.text,
      value: <ChangeIndicator change={item.change} />
    }]) || [];
    $[0] = headers;
    $[1] = slides;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== headers || $[4] !== slides || $[5] !== variant) {
    t2 = slides?.filter(row => row.sellValue !== "-" || variant != "sellTable")?.map(item_0 => [{
      key: headers[1]?.text,
      value: item_0.sellValue
    }, {
      key: headers[2]?.text,
      value: <ChangeIndicator change={item_0.change} />
    }]) || [];
    $[3] = headers;
    $[4] = slides;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== feesRow || $[8] !== headers || $[9] !== slides) {
    t3 = slides?.map(item_1 => {
      const extra_coin = item_1.coin_extras?.find(coin => coin.service_name == feesRow);
      const transaction_limit = `${extra_coin?.min_transaction_limit} - ${extra_coin?.max_transaction_limit}`;
      return [{
        key: headers[0]?.text,
        value: item_1.sellValue
      }, {
        key: headers[1]?.text,
        value: transaction_limit
      }, {
        key: headers[2]?.text,
        value: extra_coin?.daily_limit
      }];
    }) || [];
    $[7] = feesRow;
    $[8] = headers;
    $[9] = slides;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== feesRow || $[12] !== headers || $[13] !== slides) {
    t4 = slides?.map(item_2 => {
      const extra_coin_0 = item_2.coin_extras?.find(coin_0 => coin_0.service_name == feesRow);
      const transaction_limit_0 = `${extra_coin_0?.min_transaction_limit} - ${extra_coin_0?.max_transaction_limit}`;
      return [{
        key: headers[0]?.text,
        value: item_2.buyValue
      }, {
        key: headers[1]?.text,
        value: item_2.buyFeeFlat
      }, {
        key: headers[2]?.text,
        value: transaction_limit_0
      }, {
        key: headers[3]?.text,
        value: extra_coin_0?.daily_limit
      }];
    }) || [];
    $[11] = feesRow;
    $[12] = headers;
    $[13] = slides;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = {
      buyTable: t1,
      sellTable: t2,
      sellFeesAndLimits: t3,
      buyFeesAndLimits: t4
    };
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const centerRows = t5[variant];
  if (isLoading) {
    return null;
  }
  let t6;
  if ($[20] !== feesRow || $[21] !== tooltip) {
    t6 = !!feesRow && <h3 className="bg-primary-200 text-h8 text-primary-600 lg:text-h2 mb-4 flex w-full items-center justify-center gap-2 rounded-lg py-3.5 text-center font-bold lg:mb-20 lg:w-auto lg:bg-transparent lg:text-gray-600">{feesRow}{tooltip}</h3>;
    $[20] = feesRow;
    $[21] = tooltip;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== centerRows || $[24] !== currentCoin || $[25] !== feesRow || $[26] !== howToButtonLabel || $[27] !== slides || $[28] !== variant) {
    t7 = slides?.map((item_3, index) => <div onClick={() => {
      if (currentCoin == item_3.ticker) {
        setCurrentCoin("");
      } else {
        setCurrentCoin(item_3.ticker as string);
      }
    }} onKeyDown={event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        if (currentCoin == item_3.ticker) {
          setCurrentCoin("");
        } else {
          setCurrentCoin(item_3.ticker as string);
        }
      }
    }} role="button" tabIndex={0} aria-expanded={currentCoin === item_3.ticker} className="border-b border-gray-200 py-4 last:border-none" key={item_3.ticker}><div className="flex items-center justify-between" key={item_3.ticker}><div className="flex items-center gap-x-3"><PrismicNextImage fallbackAlt="" className="h-7 w-7" field={item_3.icon} /><span>{`${item_3.label}
                  (${item_3.ticker}/${item_3.currencyCode})`}</span></div><ChevronDownIcon className={clsx("h-4 w-4 transition-transform", currentCoin === item_3.ticker && "rotate-180")} /></div>{item_3.ticker === currentCoin && <><div className="space-y-4 py-5">{centerRows[index]?.map(_temp)}</div>{!feesRow && <LinkButton variant="outline" className="w-full" field={variant === "buyTable" || variant === "buyFeesAndLimits" ? item_3.buyLink : item_3.sellLink}>{howToButtonLabel?.(item_3.ticker)} <ArrowRightIcon className="h-6 w-6" /></LinkButton>}</>}</div>);
    $[23] = centerRows;
    $[24] = currentCoin;
    $[25] = feesRow;
    $[26] = howToButtonLabel;
    $[27] = slides;
    $[28] = variant;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t7) {
    t8 = <div className="rounded-lg border border-gray-200 px-6">{t7}</div>;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t6 || $[33] !== t8) {
    t9 = <div className="mb-10 lg:hidden" data-sentry-component="MobileCrypto" data-sentry-source-file="index.tsx">{t6}{t8}</div>;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
};
export default MobileCrypto;
function _temp(row_0) {
  return <div key={row_0.key} className="flex w-full justify-between"><div className="flex">{row_0.key}</div><span className="text-h8">{row_0.value}</span></div>;
}